let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("jPg5M"), load("5rLJa")]).then(() => parcelRequire('hNHih'));